import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import Api from '../../Api';
import {createAlertMessage} from '../../lib/AdminFunctions';
import Button from '../Button';
import {InputField} from '../FieldComponents';
import validateUrl from '../../lib/UrlValidator';

import './style.less';

const SocialMediaTags = [
  {icon: 'facebook-square', key: 'facebook_handle'},
  {icon: 'twitter-square', key: 'twitter_handle'},
  {icon: 'instagram', key: 'instagram_handle'},
  {icon: 'pinterest-square', key: 'pinterest_handle'},
  {icon: 'youtube-square', key: 'youtube_handle'}
];

const ErrorClass = 'error';

export default class BrandEditor extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onInput = this.onInput.bind(this);
    this.clearSavedView = this.clearSavedView.bind(this);
    this.onSaveCommand = this.onSaveCommand.bind(this);

    this.state = this.createState(props.brand);
  }

  componentWillReceiveProps(props) {
    this.setState(this.createState(props.brand));
  }

  componentDidMount() {
    window.document.addEventListener('keydown', this.onSaveCommand);
  }

  componentWillUnmount() {
    window.document.removeEventListener('keydown', this.onSaveCommand);
  }

  onSaveCommand(event) {
    const isModified = event.getModifierState('Control') || event.getModifierState('Meta');
    if (event.key === 's' && isModified) {
      event.preventDefault();
      this.handleSubmit(event);
    }
  }

  onInput(name, input, error) {
    let errorState = this.state.error;
    errorState[name] = !!error;
    this.setState({
      [name]: input,
      error: errorState
    });
  }

  createState(brand) {
    brand = brand || {};
    // Set initial error values for required fields
    let error = {
      name: !brand.name,
      url: !brand.url
    };
    const {
      minimum_order_amount_cents
    } = brand;
    let minimum_order_amount_dollars = Api.Utils.formatCents(minimum_order_amount_cents, false, true) || '';

    return {
      error,
      errorView: null,
      description: brand.description || '',
      name: brand.name || '',
      minimum_order_amount_dollars,
      lead_time_weeks: brand.lead_time_weeks || '',
      facebook_handle: brand.facebook_handle,
      twitter_handle: brand.twitter_handle,
      instagram_handle: brand.instagram_handle,
      pinterest_handle: brand.pinterest_handle,
      youtube_handle: brand.youtube_handle,
      images: brand.images,
      url: brand.url || ''
    };
  }

  submit() {
    let data = {
      description: this.state.description,
      name: this.state.name,
      url: this.state.url,
      images: this.state.images
    };


    let routeToEdit = false;
    if (this.state.token) {
      data.token = this.state.token;
    } else {
      // default to active brand
      routeToEdit = true;
      data.active = true;
    }

    if (this.state.lead_time_weeks) {
      data.lead_time_weeks = this.state.lead_time_weeks;
    }

    if (this.state.minimum_order_amount_dollars) {
      data.minimum_order_amount_cents = Api.Utils.dollarToCents(this.state.minimum_order_amount_dollars);
    }

    return Api.saveBrand(data)
      .then(
        response => {
          let state = this.createState(response);
          state.savedView = this.createSavedView();
          state.savedViewCount = (this.state.savedViewCount || 0) + 1;
          this.setState(state);
          if (routeToEdit) {
            this.context.router.push(`/admin/brand/${response.token}/edit`);
          }
        },
        error => {
          alert(createAlertMessage(error));
          this.setState({
            savedView: null,
            savedViewCount: 0,
            errorView: this.createErrorView(error)
          });
        }
      );
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.handleError()) {
      return;
    }
    return this.submit();
  }

  handleError() {
    let errorValues = Object.values(this.state.error) || [];
    let error = errorValues
      .some((value) => {
        return !!value
      });
    if (error) {
      this.setState({
        savedView: null,
        savedViewCount: 0,
        errorView: this.createErrorView()
      })
    }

    return error;
  }


  createSavedView() {
    return <div className="saved-box">Saved!</div>;
  }

  createErrorView(serverError) {
    let view;
    if (serverError) {
      view = JSON.stringify((serverError && serverError.message) || 'There was an error saving the content');
    } else {
      let messages = Object.entries(this.state.error)
        .filter((entry) => {
          return !!entry[1];
        })
        .map((entry) => {
          return `Invalid ${entry[0].replace('_', ' ')} field`;
        });
      let listItems = messages.map((m, index) => {
        let key = `error-message-${index}`;
        return <li key={key}>{m}</li>
      });
      view = <ul>{listItems}</ul>;
    }

    return <div className="admin-error-message">{view}</div>;
  }

  clearSavedView() {
    let savedViewCount = Math.max(this.state.savedViewCount - 1, 0);
    let savedView = (savedViewCount === 0) ? null : this.state.savedView;
    this.setState({
      savedViewCount,
      savedView
    });
  }

  render() {
    let socialMedia = SocialMediaTags
      .map((socialMedium) => {
        const key = socialMedium.key;
        const icon = socialMedium.icon;
        const value = this.state[key];


        if (value) {
          return (
            <div className="social-media-line" key={key}>
              <FontAwesome className="social-media-icon" name={icon}/>
              <span>{value}</span>
            </div>);
        } else {
          return null;
        }
      });

    if (this.state.savedView) {
      setTimeout(this.clearSavedView, 3000);
    }

    return (
      <div className="brand-editor">
        <form className="admin-editor" onSubmit={this.handleSubmit}>
          <div className="form-group">

            <div className="line">
              <label htmlFor="name" className="label required">Name</label>
              <InputField onInput={this.onInput}
                          required={true}
                          className={(this.state.error && this.state.error.name) ? ErrorClass : ''}
                          name="name"
                          type="text"
                          value={this.state.name}
                          placeholder="Name"/>
            </div>

            <div className="line line-block">
              <label htmlFor="description" className="label">Description</label>
              <InputField onInput={this.onInput}
                          name="description"
                          type="textarea"
                          value={this.state.description}
                          placeholder="Description"/>
            </div>

            <div className="line">
              <label htmlFor="minimum_order_amount_dollars" className="label">Min. Order $</label>
              <InputField onInput={this.onInput}
                          name="minimum_order_amount_dollars"
                          type="tel"
                          value={this.state.minimum_order_amount_dollars}
                          placeholder="Minimum Order $"/>
            </div>

            <div className="line">
              <label className="label">Average Lead Time (in weeks)</label>
              <InputField onInput={this.onInput}
                          name="lead_time_weeks"
                          type="number"
                          value={this.state.lead_time_weeks}
                          placeholder="Average Lead Time (weeks)"/>
            </div>
          </div>
          <hr/>
          <div className="form-group">
            <div className="line">
              <label htmlFor="url" className="label required"><FontAwesome name="link"/> URL</label>
              <InputField required={true}
                          className={(this.state.error && this.state.error.url) ? ErrorClass : ''}
                          disabled={this.props.brand && this.props.brand.url}
                          name="url"
                          type="text"
                          onInput={this.onInput}
                          value={this.state.url}
                          validator={validateUrl}
                          placeholder="Website"/>
            </div>

            <div className="social-media-data">
              {socialMedia}
            </div>
          </div>
          {this.state.errorView}
          {this.state.savedView}

          <div>
            <Button onClick={this.handleSubmit}>Save</Button>
          </div>
        </form>
      </div>
    );
  }
}

BrandEditor.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/components/BrandEditor/index.js
 **/